import GradingReportsContainer from './GradingReportsContainer';

export default GradingReportsContainer;
